import React, { useState, useEffect } from 'react';
import ProductosDestacados from './sections/ProductosDestacados';
import ProductosCocina from './sections/ProductosCocina';
import ProductosDormitorio from './sections/ProductosDormitorio';
import ProductosLiving from './sections/ProductosLiving';
import ProductosPlacards from './sections/ProductosPlacards';
import ProductosEntretenimiento from './sections/ProductosEntretenimiento';

const HomePage = () => {
  // Estados para los modales
  const [selectedLogo, setSelectedLogo] = useState(null);
  const [selectedComment, setSelectedComment] = useState(null);

  const [whatsappAnimation, setWhatsappAnimation] = useState(false);
  
  // Estado para el menú hamburguesa
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  
  // Estados para los tooltips de servicios
  const [activeTooltip, setActiveTooltip] = useState(null);

  // Funciones para el modal de logos
  const openLogoModal = (logo) => {
    setSelectedLogo(logo);
  };

  const closeLogoModal = () => {
    setSelectedLogo(null);
  };

  // Funciones para el modal de comentarios
  const openCommentModal = (comment) => {
    setSelectedComment(comment);
  };

  const closeCommentModal = () => {
    setSelectedComment(null);
  };



  // Función para detectar si es dispositivo móvil
  const isMobile = () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  };

  const goToWhatsapp = () => {
    const phoneNumber = '5491139057006';
    
    // URL diferente para móvil y PC - sin mensaje pre-llenado
    const whatsappUrl = isMobile() 
      ? `https://wa.me/${phoneNumber}`
      : `https://web.whatsapp.com/send?phone=${phoneNumber}`;
    
    window.open(whatsappUrl, '_blank');
  };

  // Funciones para el menú hamburguesa
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  // Funciones para los tooltips de servicios
  const showTooltip = (tooltipType) => {
    setActiveTooltip(tooltipType);
  };

  const hideTooltip = () => {
    setActiveTooltip(null);
  };

  // Función para hacer scroll al inicio
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    closeMenu(); // Cerrar menú móvil si está abierto
  };

  // Animación flotante del botón de WhatsApp
  useEffect(() => {
    const interval = setInterval(() => {
      setWhatsappAnimation(prev => !prev);
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  // Cerrar menú al hacer clic fuera de él
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.hamburger') && !event.target.closest('.nav-menu')) {
        closeMenu();
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [isMenuOpen]);

  return (
    <div className="App" id="inicio">
      {/* Top Banner */}
      <div className="top-banner">
        <div className="banner-content">
          <div className="banner-text">
            <span>¡ABONAS AL RECIBIR SIN SEÑA NI ADELANTOS!</span>
            <span>El mayor distribuidor de placares y muebles de melanina de la zona oeste.</span>
          </div>
          <div className="social-icons">
            <a href="https://www.instagram.com/tecnopilimuebles?igsh=MWEzc3BsOGpuNXUwbg==" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-instagram"></i>
            </a>
            <a href="https://www.facebook.com/share/175TEJbEVM/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
              <i className="fab fa-facebook"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="navbar">
        <div className="nav-container">
          <div className="nav-brand tecno-pili-brand" onClick={scrollToTop}>TECNO PILI</div>
          
          {/* Botón hamburguesa */}
          <div className="hamburger" onClick={toggleMenu}>
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
            <span className={`hamburger-line ${isMenuOpen ? 'active' : ''}`}></span>
          </div>
          
          <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
            <li><a href="#placards" onClick={closeMenu} className="nav-category nav-placards">Placards<span className="fire-right">🔥</span></a></li>
            <li><a href="#entretenimiento" onClick={closeMenu} className="nav-category">Entretenimiento</a></li>
            <li><a href="#cocina" onClick={closeMenu} className="nav-category">Cocina</a></li>
            <li><a href="#dormitorio" onClick={closeMenu} className="nav-category">Dormitorio</a></li>
            <li><a href="#living" onClick={closeMenu} className="nav-category">Living</a></li>
          </ul>
        </div>
      </nav>

        {/* Overlay para cerrar el menú */}
        {isMenuOpen && (
          <div className="nav-overlay active" onClick={closeMenu}></div>
        )}
        
 
        
 

              {/* Foto de inicio */}
        <section className="video-section">
          <div className="video-container">
            <img
              className="foto-inicio"
              src="/assets/img/fotoInicio/fotoInicio.jpeg"
              alt="Tecno Pili - Muebles"
            />
        </div>
      </section>

      {/* Products Sections */}
      <ProductosDestacados />

      <ProductosPlacards />

      <ProductosEntretenimiento />

      <ProductosCocina />

      <ProductosDormitorio />

      <ProductosLiving />

      {/* Comentarios de Clientes */}
      <section className="client-comments-section">
        <div className="section-container">
          <h2 className="section-title">Comentarios de nuestros clientes:</h2>
          <div className="comments-container">
            <div className="comments-layout">
              {/* Primera fila: Comentarios 1 y 2 */}
              <div className="comments-row">
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario1.jpg')}>
                  <img src="/assets/img/comentarios/comentario1.jpg" alt="Comentario Cliente 1" className="comment-image" />
                </div>
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario2.jpg')}>
                  <img src="/assets/img/comentarios/comentario2.jpg" alt="Comentario Cliente 2" className="comment-image" />
                </div>
              </div>
              
              {/* Segunda fila: Comentarios 7, 8 y 9 */}
              <div className="comments-row">
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario7.jpg')}>
                  <img src="/assets/img/comentarios/comentario7.jpg" alt="Comentario Cliente 7" className="comment-image" />
                </div>
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario8.jpg')}>
                  <img src="/assets/img/comentarios/comentario8.jpg" alt="Comentario Cliente 8" className="comment-image" />
                </div>
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario9.jpg')}>
                  <img src="/assets/img/comentarios/comentario9.jpg" alt="Comentario Cliente 9" className="comment-image" />
                </div>
              </div>
              
              {/* Tercera fila: Comentarios 5 y 6 */}
              <div className="comments-row">
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario5.jpg')}>
                  <img src="/assets/img/comentarios/comentario5.jpg" alt="Comentario Cliente 5" className="comment-image" />
                </div>
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario6.jpg')}>
                  <img src="/assets/img/comentarios/comentario6.jpg" alt="Comentario Cliente 6" className="comment-image" />
                </div>
              </div>
              
              {/* Cuarta fila: Comentario 4 centrado */}
              <div className="comments-row single-comment">
                <div className="comment-card" onClick={() => openCommentModal('/assets/img/comentarios/comentario4.jpg')}>
                  <img src="/assets/img/comentarios/comentario4.jpg" alt="Comentario Cliente 4" className="comment-image" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="logo-container">
            <img 
              src="/assets/img/logo/logo1.jpeg" 
              alt="Logo 1" 
              className="app-logo"
              onClick={() => openLogoModal('/assets/img/logo/logo1.jpeg')}
            />
            <img 
              src="/assets/img/logo/logo2.jpeg" 
              alt="Logo 2" 
              className="app-logo"
              onClick={() => openLogoModal('/assets/img/logo/logo2.jpeg')}
            />
          </div>
          
          <div className="services-categories">
            <div 
              className="service-item"
              onMouseEnter={() => showTooltip('envio')}
              onMouseLeave={hideTooltip}
              onClick={() => showTooltip('envio')}
            >
              <i className="fas fa-truck service-icon"></i>
              <div className="service-text">Métodos de envío</div>
              {activeTooltip === 'envio' && (
                <div className="service-tooltip">
                  Envios a CABA y GBA a bajo costo!
                </div>
              )}
            </div>
            <div 
              className="service-item"
              onMouseEnter={() => showTooltip('pago')}
              onMouseLeave={hideTooltip}
              onClick={() => showTooltip('pago')}
            >
              <i className="fas fa-credit-card service-icon"></i>
              <div className="service-text">Medios de pago</div>
              {activeTooltip === 'pago' && (
                <div className="service-tooltip">
                  Efectivo<br />
                  Transferencia<br />
                  Tarjeta de credito
                </div>
              )}
            </div>
            <div 
              className="service-item"
              onMouseEnter={() => showTooltip('retiro')}
              onMouseLeave={hideTooltip}
              onClick={() => showTooltip('retiro')}
            >
              <i className="fas fa-map-marker-alt service-icon"></i>
              <div className="service-text">Punto de retiro</div>
              {activeTooltip === 'retiro' && (
                <div className="service-tooltip">
                  ¡Vení a retirar tu mueble a nuestro depósito en Merlo!
                </div>
              )}
            </div>
          </div>
          
          <div className="footer-right">
            <div className="social-section">
              <h4>Seguinos:</h4>
              <div className="social-links">
                <a href="https://www.instagram.com/tecnopilimuebles?igsh=MWEzc3BsOGpuNXUwbg==" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.facebook.com/share/175TEJbEVM/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* Copyright Footer */}
      <div className="copyright-footer">
        <div className="copyright-container">
          <p>&copy; 2025 Maximo Augusto Paulucci. Todos los derechos reservados.</p>
        </div>
      </div>

      {/* WhatsApp Float Button */}
      <div className={`whatsapp-float ${whatsappAnimation ? 'floating' : ''}`}>
        <button className="whatsapp-button" onClick={goToWhatsapp}>
          <i className="fab fa-whatsapp"></i>
        </button>
      </div>

      {/* Logo Modal */}
      {selectedLogo && (
        <div className="logo-modal-overlay" onClick={closeLogoModal}>
          <div className="logo-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="logo-modal-close" onClick={closeLogoModal}>×</button>
            <img src={selectedLogo} alt="Logo" className="logo-modal-image" />
          </div>
        </div>
      )}

      {/* Comment Modal */}
      {selectedComment && (
        <div className="comment-modal-overlay" onClick={closeCommentModal}>
          <div className="comment-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="comment-modal-close" onClick={closeCommentModal}>×</button>
            <img src={selectedComment} alt="Comentario Cliente" className="comment-modal-image" />
          </div>
        </div>
      )}


    </div>
  );
};

export default HomePage;
